<!--
    描述：人员管理--右侧组织架构
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success" size="small" icon="el-icon-check"
                               v-if="roleBtns.includes('menu_permission_save')" @click="saveClick('roleMenu')">保存
                    </el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="menusContent" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="menusTree"
                                 :height="menusTreeData.tableH"
                                 :data="menusTreeData.tableData"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                                 @node-click="nodeClick"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/system/menu.js'
    import {getRoleMenuByRoleId, saveOrUpdateRoleMenu} from 'api/system/role.js'
    import { getLimitMenuByLimitIdMore } from 'api/system/limitRole.js'
    export default {
        components: {},
        data() {
            return {
                roleId: '',
                treeDefaultCheckedKey: [],

                btnLoading: false,
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '650px',
                    mode: 'add',
                },
                menusTreeData: {
                    loading: false,
                    tableH: 200,
                    tableData: [],

                    tableOriData: [],
                    tableByRoleData: [],
                },
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },

                //limitRoleBtnShow : true,
            }
        },
        methods: {
            getMenuTreeTableData() {
                let that = this
                let param = {};
                selectTree(param).then(res => {
                    if (res.operationCode == 1) {
                        that.menusTreeData.tableOriData = res.data;
                        that.menusTreeData.tableData = that.menusTreeData.tableOriData.concat();
                    }
                });
            },
            getMenuTreeInfoByRoleId(obj) {
                let that = this

                /*
                let menuArrayTree = that.menusTreeData.tableData.concat()
                let menuTreeArray = that.$utils.toTreeArray(menuArrayTree)
                menuTreeArray = menuTreeArray.map(prop=> {
                    return {...prop, disabled : false}
                })
                */

                /*
                if(limitRoleObj != '') {
                    that.limitRoleBtnShow = typeof(limitRoleObj.limitRoleIdList.find(roleId=> {return roleId==obj.id })) != 'undefined' ? true : false
                }
                */

                let limitId = ''//
                if(limitId != '') {
                    let limitParam = {
                        limitId : limitId,
                        roleId : obj.id,
                    }
                    getLimitMenuByLimitIdMore(limitParam).then(res => {
                        if (res.operationCode == 1) {
                            let limitMenuArr = res.data.limitMenuIdList.concat()
                            menuTreeArray = menuTreeArray.map(prop=> {
                                let disabled = typeof(limitMenuArr.find(menuId=> {return menuId==prop.id })) != 'undefined' ? false : true
                                return {...prop, disabled : disabled}
                            })
                            that.menusTreeData.tableData = that.$utils.toArrayTree(menuTreeArray).concat()
                        }
                    })
                }

                that.roleId = obj.id
                that.treeDefaultCheckedKey = []
                let param = {roleId: obj.id}
                getRoleMenuByRoleId(param).then(res => {
                    if (res.operationCode == 1) {
                        that.treeDefaultCheckedKey = res.data
                    }
                });
            },
            saveClick() {
                let that = this
                if (that.roleId == '') {
                    that.$message({message: '请选择角色信息', type: 'warning'});
                    return;
                }

                let menuIdsSelection = [];
                let checkSelection = this.$refs.menusTree.getCheckedKeys().concat()
                let param = {
                    roleId: that.roleId,
                    menuIdsSelection: checkSelection
                }
                console.log(" param-menuIds = " + param.menuIdsSelection);
                saveOrUpdateRoleMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        that.$message({message: '保存成功', type: 'success'});
                    }
                });
            },
            nodeClick(obj) {
                this.$emit('row-click', obj)
            },
            // 关闭弹窗事件
            handleClose() {

            },
            // 确定按钮事件
            doSave() {
                this.$refs.addMenu.doSave()
            },

            //新增/编辑菜单成功
            handleSuccess() {
                this.dialogObj.visible = false;
                this.getMenuTreeTableData()
            },
        },
        created() {
            this.getMenuTreeTableData();
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
            }
        }
    }
</script>
<style lang="less" scoped>
    .tree-content {
        overflow-y: auto;
        padding: 5px 0px;
    }

    .w-table-page {
        padding-bottom: 5px;
    }
</style>
